export const epbase = ['smart-icy-glitter','bemeowdapp', 'googleapis.com']